import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { uniq } from 'lodash-es';
import { httpClient } from '@s20/services/httpClient';
import { FlexColumnCenter, FormCircularProgress, FormContext } from '../../common/forms/FormElements';
import { ApiRoutes } from '../../Common';
import { Alert } from '../../common/Modal';
import { MapDataContext } from './MapDataContext';

export const MapData = ({ children }) => {
    const { values } = useContext(FormContext);
    const { employeeDispatchLocation = [], dispatchOfficeLocationId = null, selectedDate } = values;

    const payload = {
        selectedDate,
        employeeDispatchLocation: uniq([
            ...employeeDispatchLocation || [],
            ...dispatchOfficeLocationId ? [Number(dispatchOfficeLocationId)] : [],
        ]),
    };

    const { data } = useQuery({
        queryKey: ['mapData', JSON.stringify(payload)],
        queryFn: async () => {
            Alert.show({
                backdrop: 'static',
                body: (
                    <FlexColumnCenter className="align-items-center p-4">
                        <FormCircularProgress />

                        <span className="h5 mt-3">Loading map data...</span>
                    </FlexColumnCenter>
                ),
            });

            const response = await httpClient.post(
                ApiRoutes.dispatchPlus.mapData(),
                payload,
            );

            Alert.hide();

            return response;
        },
    });

    return (
        <MapDataContext.Provider value={data ?? {}}>
            {children}
        </MapDataContext.Provider>
    );
};